import type { FolderUser, FolderSearchResult } from '../../types';
import { useState, useMemo } from 'react';
import { UserListItem } from '~/features/common';
import { useSearchUsersAndGroups } from '../../api';
import { AutocompleteInput } from './AutocompleteInput';

export interface PermissionSearchProps {
  onSelect: (permissionUser: FolderUser) => void;
}

const mapResultToUser = (result: FolderSearchResult): FolderUser => {
  const folderUser = {
    userId: null,
    groupId: null,
    email: null,
    displayName: result.name,
    imgUrl: result.avatar ?? null,
    accessLevel: window.APP_CONSTANTS.FOLDER_ACCESS_LEVEL_TYPES.READ,
    inheritedFolder: null,
  };

  return result.isGroup
    ? {
        ...folderUser,
        groupId: Number(result.id.replace('group_', '')),
      }
    : {
        ...folderUser,
        email: result.label,
        userId: Number(result.id.replace('user_', '')),
      };
};

export function PermissionSearch({ onSelect }: PermissionSearchProps) {
  const [searchValue, setSearchValue] = useState('');
  const { data: users = [] } = useSearchUsersAndGroups(encodeURIComponent(searchValue));
  const sortedUsers = useMemo(() => [...users].sort((a, b) => a.name.localeCompare(b.name)), [users]);

  return (
    <div>
      <AutocompleteInput
        onSelect={onSelect}
        onSearch={setSearchValue}
        results={sortedUsers}
        renderResult={(result, onClick) => {
          const user = mapResultToUser(result);

          return (
            <UserListItem
              onClick={() => onClick(user)}
              name={user.displayName}
              avatar={user.imgUrl}
              label={user.email}
              isGroup={!!user.groupId}
            />
          );
        }}
      />
    </div>
  );
}
